import React from "react";
import {
  FaMountainCity,
  FaArrowUpFromGroundWater,
  FaCompassDrafting,
  FaTrowelBricks,
  FaHelmetSafety
} from "react-icons/fa6";
import { BiCheckShield } from "react-icons/bi";
import { BsArrowRight, BsBrightnessAltHigh, BsFileEasel } from "react-icons/bs";
import mainImg from "../assets/img/alt-services.jpg";
import { useTranslation } from "react-i18next";

import Header from "../../contruction-home/components/Header";
import Footer from "../../contruction-home/components/Footer";
import Hero from "../../contruction-home/components/Hero";
import NormalUserLayout from "../../layouts/NormalUserLayout/NormalUserLayout";

const weitereleistungen = () => {
  const { t } = useTranslation();

  const services = [
    {
      id: 1,
      icon: <FaMountainCity />,
      title: t("Wärmedämmverbundsystem.items.1.title"),
      description: t("Wärmedämmverbundsystem.items.1.description"),
      delay: 100
    },
    {
      id: 2,
      icon: <FaArrowUpFromGroundWater />,
      title: t("Wärmedämmverbundsystem.items.2.title"),
      description: t("Wärmedämmverbundsystem.items.2.description"),
      delay: 200
    },
    {
      id: 3,
      icon: <FaCompassDrafting />,
      title: t("Wärmedämmverbundsystem.items.3.title"),
      description: t("Wärmedämmverbundsystem.items.3.description"),
      delay: 300
    },
    {
      id: 4,
      icon: <FaTrowelBricks />,
      title: t("Wärmedämmverbundsystem.items.4.title"),
      description: t("Wärmedämmverbundsystem.items.4.description"),
      delay: 400
    },
    {
      id: 5,
      icon: <FaHelmetSafety />,
      title: t("Wärmedämmverbundsystem.items.5.title"),
      description: t("Wärmedämmverbundsystem.items.5.description"),
      delay: 500
    },
    {
      id: 6,
      icon: <FaArrowUpFromGroundWater />,
      title: t("Wärmedämmverbundsystem.items.6.title"),
      description: t("Wärmedämmverbundsystem.items.6.description"),
      delay: 600
    }
  ];

  const iconBoxes = [
    {
      id: 1,
      icon: <BsFileEasel className="flex-shrink-0" />,
      title: t("Wärmedämmverbundsystem.alt.boxes.1.title"),
      link: "#",
      description: t("Wärmedämmverbundsystem.alt.boxes.1.description"),
      delay: 300
    },
    {
      id: 2,
      icon: <BiCheckShield className="flex-shrink-0" />,
      title: t("Wärmedämmverbundsystem.alt.boxes.2.title"),
      link: "#",
      description: t("Wärmedämmverbundsystem.alt.boxes.2.description"),
      delay: 400
    },
    {
      id: 3,
      icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
      title: t("Wärmedämmverbundsystem.alt.boxes.3.title"),
      link: "#",
      description: t("Wärmedämmverbundsystem.alt.boxes.3.description"),
      delay: 500
    },
    {
      id: 4,
      icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
      title: t("Wärmedämmverbundsystem.alt.boxes.4.title"),
      link: "#",
      description: t("Wärmedämmverbundsystem.alt.boxes.4.description"),
      delay: 600
    }
  ];

  return (
    <>
      <div className="ConstructionHome">
        <NormalUserLayout>
          <Header />
          <main className="main">
            {/* <div style={{ background: "rgba(0, 0, 0, 1)" }}> */}
            <Hero compact />
            {/* Alt Services Section */}
            <section id="alt-services" className="alt-services section">
              <div className="container">
                <div className="row justify-content-around gy-4">
                  <div
                    className="col-lg-5 d-flex flex-column justify-content-center"
                    data-aos="fade-up"
                    data-aos-delay={200}
                  >
                    <p>{t("weitereleistungen.alt.heading")}</p>
                    <h3>{t("weitereleistungen.alt.desc")}</h3>

                    <div className="icon-box d-flex position-relative" data-aos="fade-up">
                      <div>
                        <p>{t("weitereleistungen.alt.boxes.1.description1")}</p>
                      </div>
                    </div>

                    <div className="icon-box d-flex position-relative" data-aos="fade-up">
                      <div>
                        <p>{t("weitereleistungen.alt.boxes.1.description2")}</p>
                      </div>
                    </div>

                    <div className="icon-box d-flex position-relative" data-aos="fade-up">
                      <div>
                        <p>{t("weitereleistungen.alt.boxes.1.description3")}</p>
                      </div>
                    </div>
                  </div>

                  {/* --------------------------------------- */}

                  <div
                    className="col-lg-5 d-flex flex-column justify-content-center"
                    data-aos="fade-up"
                    data-aos-delay={200}
                  >
                    <div className="icon-box d-flex position-relative" data-aos="fade-up">
                      <div>
                        <h4>
                          <a href="#" className="stretched-link">
                            {t("weitereleistungen.alt.boxes.2.title")}
                          </a>
                        </h4>
                        <p>{t("weitereleistungen.alt.boxes.2.description")}</p>
                      </div>
                    </div>

                    <div className="icon-box d-flex position-relative" data-aos="fade-up">
                      <div>
                        <h4>
                          <a href="#" className="stretched-link">
                            {t("weitereleistungen.alt.boxes.3.title")}
                          </a>
                        </h4>
                        <p>{t("weitereleistungen.alt.boxes.3.description")}</p>
                      </div>
                    </div>

                    <div className="icon-box d-flex position-relative" data-aos="fade-up">
                      <div>
                        <h4>
                          <a href="#" className="stretched-link">
                            {t("weitereleistungen.alt.boxes.4.title")}
                          </a>
                        </h4>
                        <p>{t("weitereleistungen.alt.boxes.4.description")}</p>
                      </div>
                    </div>

                    <div className="icon-box d-flex position-relative" data-aos="fade-up">
                      <div>
                        <h4>
                          <a href="#" className="stretched-link">
                            {t("weitereleistungen.alt.boxes.5.title")}
                          </a>
                        </h4>
                        <p>{t("weitereleistungen.alt.boxes.5.description")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
        </NormalUserLayout>
      </div>
    </>
  );
};

export default weitereleistungen;
